import { withCurrencyLogo } from '@pancakeswap/widgets-internal'
import { Currency } from '@pancakeswap/sdk'
import { CurrencyLogo } from '../Logo'

export default withCurrencyLogo<Currency>(CurrencyLogo)
